import StateOfPersonalizationReport2023View from 'views/StateOfPersonalizationReport2023'

const StateOfPersonalizationReport = () => {
  return <StateOfPersonalizationReport2023View />
}

export default StateOfPersonalizationReport
